/**
 * `fieldKey` derivation (DNKADM-0270) — its own module (not the dialog) per the
 * DNKADM-0249 precedent: a non-component export beside a component breaks Fast
 * Refresh (`react-refresh/only-export-components`).
 */

/**
 * Derive a stable snake_case `fieldKey` from a display label: lowercased,
 * alphanumerics kept, everything else collapsed to single `_`, trimmed —
 * `"Preferred Bay"` → `"preferred_bay"`. The dialog's Advanced override remains
 * for anything the slug can't express; the server's key rules (`400`/`409`)
 * stay the real gate.
 */
export function deriveFieldKey(label: string): string {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
